// de_pms_personal_dashboard.ts
// Tłumaczenia dla PersonalDashboard.tsx

export const dePmsPersonalDashboard = {

  // ── Powitania ─────────────────────────────────────────────────────────────
  greetings: {
    morning:   "Guten Tag",
    afternoon: "Guten Tag",
    evening:   "Guten Abend",
  },

  // ── Sekcje widgety ────────────────────────────────────────────────────────
  sections: {
    liveActivity:   "Live-Aktivitaet",
    housekeepingQueue:"Housekeeping-Warteschlange",
    openIncidents:  "Offene Vorfaelle",
    handover:       "Uebergabe",
    finance:        "Finanzen",
    activity:       "Aktivitaet",
    operations:     "Operationen",
    maintenance:    "Wartung",
    guests:         "Gaeste",
  },

  // ── Pasek narzędzi ────────────────────────────────────────────────────────
  toolbar: {
    customize: "Anpassen",
    done:      "Fertig",
    enter:     "Oeffnen",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    arrivalToday:           "Anreise heute",
    arrivalsToday:          "Anreisen heute",
    assignedToHousekeeping: "Housekeeping zugewiesen",
    needsCleaning:          "Benoetigt Reinigung",
    occupancy:              "Auslastung",
    revenue:                "Umsatz",
    openIssues:             "Offene Probleme",
    noCriticalIssues:       "Keine kritischen Probleme",
    noPickupData:           "Keine Pickup-Daten",
    noRevenueData:          "Keine Umsatzdaten",
    noRevenueHistory:       "Keine Umsatzhistorie",
    noLinkedIncident:       "Kein verknuepfter Vorfall zur Zuweisung",
    noLinkedIncidentResolve:"Kein verknuepfter Vorfall zur Loesung",
  },

  // ── Przekazanie ───────────────────────────────────────────────────────────
  handover: {
    acknowledged: "Uebergabe bestaetigt",
    noteAdded:    "Uebergabenotiz hinzugefuegt",
    markedResolved:"Als geloest markiert",
  },

} as const;

export default dePmsPersonalDashboard;
